import {
  ArrowBack as ArrowBackIcon,
  ArrowForward as ArrowForwardIcon,
  Close as CloseIcon,
} from "@mui/icons-material";
import {
  Box,
  IconButton,
  Modal,
  Slide,
  Stack,
  Typography,
} from "@mui/material";
import { formatSize, toLocaleDateTimeString } from "@utils";
import { Dayjs } from "dayjs";

// TODO: this can change to accept just the type-narrowed Attachment object
// itself, once comments have been adapted to use the Attachment type.
type Props = {
  title: string;
  src?: string;
  alt: string;
  size?: number;
  createdAt?: Dayjs;
  open: boolean;
  onClose: () => void;
  onNext?: () => void;
  onPrevious?: () => void;
};

export const ImagePreviewModal = ({
  title,
  src,
  alt,
  size,
  createdAt,
  open,
  onClose,
  onNext,
  onPrevious,
}: Props) => {
  const buttonsEnabled = onNext && onPrevious;
  const createdAtText =
    createdAt && `Uploaded: ${toLocaleDateTimeString(createdAt)}`;
  const infoText = [formatSize(size || 0), createdAtText]
    .filter(Boolean)
    .join(" • ");

  return (
    <Modal
      open={open}
      onClose={onClose}
      hideBackdrop
      data-testid="image-preview-modal"
    >
      <Slide in={open} direction="up" timeout={150}>
        <Stack sx={{ height: "100%", backgroundColor: "grey.900" }}>
          <Stack
            direction="row"
            sx={{
              justifyContent: "space-between",
              color: "primary.contrastText",
              padding: 2,
              alignItems: "center",
            }}
          >
            <Box>
              <Typography>{title}</Typography>
              <Typography>{infoText}</Typography>
            </Box>
            <IconButton onClick={onClose} color="inherit">
              <CloseIcon />
            </IconButton>
          </Stack>
          <Stack
            direction="row"
            sx={{
              flex: 1,
              justifyContent: "space-between",
              alignItems: "center",
              padding: 2,
            }}
          >
            {buttonsEnabled && (
              <IconButton onClick={onPrevious} color="secondary">
                <ArrowBackIcon fontSize="large" />
              </IconButton>
            )}
            <Box sx={{ height: "85vh", flexGrow: 1, paddingX: 2 }}>
              <Box
                component="img"
                src={src}
                alt={alt}
                sx={{
                  objectFit: "contain",
                  height: 1,
                  width: 1,
                }}
              />
            </Box>
            {buttonsEnabled && (
              <IconButton onClick={onNext} color="secondary">
                <ArrowForwardIcon fontSize="large" />
              </IconButton>
            )}
          </Stack>
        </Stack>
      </Slide>
    </Modal>
  );
};
